import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const Styled = styled.div`
  padding: 0 18px;
  background-color: ${Theme.color.nearWhite};
  height: 100%;
  overflow: scroll;
`;
